import React from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';

// Select em formato pill (borda arredondada) — para filtros ao lado da busca (ex.: Status, Country).
const styles = {
  root: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 999,
    height: 40,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'background 0.15s ease',
    '&:hover': {
      backgroundColor: '#fafafa',
    },
  },
  select: {
    paddingLeft: 16,
    paddingRight: '32px !important',
    fontSize: '0.9em',
    color: '#1a1a1a',
    display: 'flex',
    alignItems: 'center',
    height: '100% !important',
    boxSizing: 'border-box',
    '&:focus': {
      backgroundColor: 'transparent',
      borderRadius: 999,
    },
  },
  icon: {
    color: '#9a9a9a',
    right: 10,
  },
};

const FilterSelect = ({ classes, className, ...rest }) => (
  <Select
    disableUnderline
    classes={{ select: classes.select, icon: classes.icon }}
    className={[classes.root, className].filter(Boolean).join(' ')}
    {...rest}
  />
);

FilterSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles)(FilterSelect);
